module.exports = __webpack_public_path__ + "img/img13_1.f510c225.svg";